import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getApiBase } from "../apiBase";

export default function VerifyOTP() {

  const { state } = useLocation();
  const navigate = useNavigate();

  const [otp, setOtp] = useState("");
  const [error, setError] = useState("");

  const verify = async () => {

    const res = await fetch(`${getApiBase()}/verify-otp`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: state.email,
        otp
      })
    });

    const data = await res.json();

    if (!res.ok) {
      return setError(data.detail);
    }

    alert("Email verified! Please login.");
    navigate("/");
  };

  return (
    <div className="p-10">
      <h2>Enter OTP</h2>

      <input
        value={otp}
        onChange={e => setOtp(e.target.value)}
      />

      <button onClick={verify}>Verify</button>

      {error}
    </div>
  );
}
